import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Title } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import { HorizontalPlacement } from 'utils/types'

export const SImageContainer = styled.div<{ imagePlacement?: HorizontalPlacement }>`
  grid-row: 1 / span 2;

  ${({ imagePlacement }) =>
    imagePlacement === 'right'
      ? css`
          grid-column: 2;
        `
      : null}

  & img {
    width: 100%;
    object-fit: contain;
  }

  @media ${BREAKPOINTS.MD.max} {
    order: 2;
  }
`

export const STitle = styled(Title)`
  @media ${BREAKPOINTS.MD.min} {
    margin-bottom: 1.5rem;
  }
  @media ${BREAKPOINTS.MD.max} {
    order: 1;
    margin-bottom: 0.5rem;
  }
`

export const SDetails = styled.div`
  display: flex;
  flex-direction: column;

  @media ${BREAKPOINTS.MD.max} {
    order: 3;
  }
`

export const SActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-column: 1 / span 2;
  margin-top: 2rem;

  @media ${BREAKPOINTS.MD.max} {
    order: 4;
    margin-top: 1rem;
    & button {
      width: 100%;
    }
  }
`

export const SCenteredTextImageSection = styled.section<{
  imagePlacement?: HorizontalPlacement
}>`
  --width: 1290px;
  --space: max(5vw, calc((100% - var(--width)) / 2));

  display: grid;
  grid-column-gap: ${pxToRem(120)}rem;
  grid-template-rows: auto 1fr auto;
  align-items: center;

  ${({ imagePlacement }) => {
    if (imagePlacement === 'right') {
      return css`
        grid-template-columns: 3fr 5fr;
        padding-left: var(--space);
        & ${SActionWrapper} {
          padding-right: calc(var(--space) * 2);
        }
      `
    } else {
      return css`
        grid-template-columns: 5fr 3fr;
        padding-right: var(--space);
        & ${SActionWrapper} {
          padding-left: calc(var(--space) * 2);
        }
      `
    }
  }}

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding-left: var(--space);
    padding-right: 0;
    & > *:not(:last-child) {
      margin-bottom: 1rem;
    }
    & ${SDetails}, ${STitle}, ${SActionWrapper} {
      padding-left: 0;
      padding-right: var(--space);
    }
  }
`
